import store from '@/store';

export default function translate(key) {
  return store.state.translations[key] || key;
}
